import { format } from 'date-fns';
import { enGB, ru } from 'date-fns/locale';

import { LOCALE_CODES } from '@/constants/variables';

const localeByLang = {
  [LOCALE_CODES.ru]: ru,
  [LOCALE_CODES.en]: enGB,
};

export const useFormatDate = (date, formatStr = 'd MMMM yyyy') => {
  const { locale } = useI18n();

  return format(date, formatStr, {
    locale: localeByLang[locale.value] || localeByLang[LOCALE_CODES.ru],
  });
};
